import React from "react";
import "../../../_editor/components/canvas/editor_box/screen_training/_screen_training.scss";
export default function GuideTagDisplayRenderer({ tagRef, tagValues, visor }) {
  const val = tagValues && tagRef ? tagValues[tagRef] : null;

  if (visor) {
    return (
      <div
        className="guide-tag-display"
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
        }}
      >
        {val != null && val !== "" ? (
          val
        ) : tagRef ? (
          "{" + tagRef + "}"
        ) : (
          <span style={{ color: "#aaa" }}>—</span>
        )}
      </div>
    );
  }

  return (
    <div
      className="guide-tag-display"
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "auto",
        cursor: "move",
      }}
    >
      {tagRef ? "{" + tagRef + "}" : <span style={{ color: "#aaa" }}>—</span>}
    </div>
  );
}
